import { useQuery } from '@tanstack/react-query'
import client from '../api/client.js'

export function useActions({
  pillar = 'all',
  urgency = 'all',
  dc = 'all',
  category = 'all',
  scope = 'all',                    // RF-T04
  hideLowRisk = false,              // RF-T03
  lowRiskThreshold = 1000,          // RF-T03
  sortBy = 'urgency',
  sortDir = 'asc',
  page = 1,
  pageSize = 50,
} = {}) {
  return useQuery({
    queryKey: [
      'actions', pillar, urgency, dc, category, scope,
      hideLowRisk, lowRiskThreshold, sortBy, sortDir, page, pageSize,
    ],
    queryFn: async () => {
      const { data } = await client.get('/actions', {
        params: {
          pillar, urgency, dc, category,
          scope,
          hide_low_risk: hideLowRisk,
          low_risk_threshold: lowRiskThreshold,
          sort_by: sortBy, sort_dir: sortDir,
          page, page_size: pageSize,
        },
      })
      return data
    },
    staleTime: 5 * 60 * 1000,
  })
}

export function useActionsTop5({ scope = 'all' } = {}) {
  return useQuery({
    queryKey: ['actions', 'top5', scope],
    queryFn: async () => {
      const { data } = await client.get('/actions/top5', { params: { scope } })
      return data
    },
    staleTime: 5 * 60 * 1000,
  })
}
